// https://bl.ocks.org/veltman/1071413ad6b5b542a1a3
// https://www.npmjs.com/package/gif.js.optimized
// https://github.com/jnordberg/gif.js
// https://www.npmjs.com/package/d3-queue
// http://codepen.io/osublake/pen/JKEjLb
// https://greensock.com/docs/#/HTML5/GSAP/TimelineLite/
// https://github.com/spite/ccapture.js/

// Velocity
// Snap
// Greensock

// https://bl.ocks.org/veltman/ff864215009174bc5d164ec3533125c2#index.html

import {
  Component, Input, OnInit, AfterViewInit, OnDestroy,
  ViewChild, ElementRef, Output, EventEmitter
} from '@angular/core';
import { TweenLite, TimelineMax, Power2 } from 'gsap';
import * as d3 from 'd3';
import * as _ from 'lodash';
// import numeral from 'numeral';
import * as numeral from 'numeral';
import 'numeral/locales/nl-nl';
import 'numeral/locales/en-gb';
import 'numeral/locales/fi';
declare var GIF: any;
declare var MediaRecorder: any;

// @Component({
//   template: `<div #container></div>`
// })
export class AnimationComponent implements OnInit, AfterViewInit, OnDestroy {

  public id: string;
  public standardFontList = ['Akko', 'Soho'];
  public fontList = ['Akko', 'Soho'];
  public params: any;

  public values = {};
  public width;
  public height;
  public parameters: any;
  public timings: any;
  public data: any;
  private _scalable: boolean;
  public _embedFonts: boolean;
  @Input() public frameRate = 15;
  @Input() public type: string;
  @Input() public category: string;
  @Input() public inputParams: any;
  public paramObject: any = {};

  @ViewChild('svg') svgRef: ElementRef;
  @ViewChild('temp') tempRef: ElementRef;
  @ViewChild('output') outputRef: ElementRef;
  public svgElement;
  public host;
  public animation = new TimelineMax({ repeat: -1 });
  public blob;
  public dataUrl;
  public animate: boolean = true;
  private queue;

  @Output() public paramEmitter: EventEmitter<any> = new EventEmitter();
  @Output() public gifBlobEmitter: EventEmitter<any> = new EventEmitter();
  @Output() public gifDataUrlEmitter: EventEmitter<any> = new EventEmitter();
  @Output() public videoBlobEmitter: EventEmitter<any> = new EventEmitter();
  @Output() public videoDataUrlEmitter: EventEmitter<any> = new EventEmitter();
  @Output() public xmlEmitter: EventEmitter<any> = new EventEmitter();
  @Output() public svgEmitter: EventEmitter<any> = new EventEmitter();
  @Output() public progressEmitter: EventEmitter<any> = new EventEmitter();
  @Output() public animationProgressEmitter: EventEmitter<any> = new EventEmitter();

  constructor ( ) { }

  ngOnInit() {
    this.params = this.inputParams || this.paramObject[this.type];
    // console.log(this.params);
    this.id = this.makeID(10);
    if (this.category === 'animation') {
      this._embedFonts = true;
    }
    if (this.params) {
      this.paramEmitter.emit(this.params);
      this.setDefaultParameters();

      // Make animation
      this.svgElement = this.svgRef.nativeElement;
      this.host = d3.select(this.svgElement);
      this.createAll();
    }
    this.animation.eventCallback('onUpdate', () => {this.animationProgressEmitter.emit(this.animation.progress())});
  };

  ngAfterViewInit() {};

  ngOnDestroy() {
    this.abortRender();
    let result = this.animation.kill();
  };

  public setDefaultParameters() {
    // Set default parameters
    let defaultParameterValues = {};
    _.map(_.keys(this.params['parameters']), (key) => {
      defaultParameterValues[key] = this.params['parameters'][key]['default'];
    });
    if (this._scalable !== null && this._scalable !== undefined) {
      defaultParameterValues['scalable'] = this._scalable;
    }
    this.parameters = defaultParameterValues;

    // Set default timings
    let defaultTimingValues = {};
    _.map(_.keys(this.params['timings']), (key) => {
      defaultTimingValues[key] = this.params['timings'][key]['default'];
    });
    this.timings = defaultTimingValues;

    // Set default data (sorry)
    this.data = (this.params['data'] || {})['values'];
  }

  public setNewParameters(params, timings, data) {
    this.parameters = params;
    this.timings = timings;
    this.data = data;
    // console.log(this.data);
  }

  public makeID(length: number) {
    let text = '';
    let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  };

  public clearAnimation() {
    this.animation = new TimelineMax({ repeat: -1 });
  };

  public async calculateValues() {};

  public async createElements(): Promise<any> {
    // Draw all elements onto the SVG
  };

  public async createAnimation(noAnimation: boolean = false): Promise<any> {
    // Animate all elements and return the main timeline
    // wrap animation in an if statement so that
    // noAnimation === true doesn't actually make the animation
  };

  public async createAll(returnToProgress?: boolean): Promise<any> {
    // Go through all 3 steps to make animation
    // and restart the animation
    let lastProgress = this.animation.progress();
    this.kill();
    this.reinitialize();
    await this.calculateValues();
    await this.createElements();
    if (this.category !== 'still') {
      await this.createAnimation();
      if (returnToProgress) {
        this.animation.progress(lastProgress);
        this.animation.paused(true);
      } else {
        this.restart();
      }
    } else {
      this.svgEmitter.emit(this.svgElement);
    }
  };

  private captureAnimationToGif(callback?) {

    if (this.animation) {
      this.reinitialize();
      let duration = this.animation.duration();
      let frames = duration * this.frameRate;

      let gif = new GIF({
        workers: 8,
        quality: 10,
        background: '#fff',
        workerScript: '/assets/gif.worker.js',
        // debug: true,
      });

      this.queue = d3.queue(1);

      let captureFrame = (f, cb) => {
        let progress = f / frames;
        this.animation.progress(progress);
        let xml = new XMLSerializer().serializeToString(this.svgElement);
        let blob = new Blob([xml], { type: 'image/svg+xml' });
        let img = new Image();
        img.crossOrigin = 'Anonymous';

        img.onload = function() {
          let delay = 1000 * duration / frames;
          gif.addFrame(this, {
            delay: delay,
          });
          cb(null);
        };

        img.src = URL.createObjectURL(blob);
        return {
          abort: () => { console.log('Abort'); }
        };
      };

      gif.on('finished', (blob) => {
        this.blob = blob;
        this.gifBlobEmitter.emit(blob);
        this.dataUrl = URL.createObjectURL(blob);
        this.gifDataUrlEmitter.emit(this.dataUrl);
        if (callback) {
          callback();
        }
      });

      gif.on('progress', (progress) => {
        // console.log(progress);
        this.progressEmitter.emit(progress);
      });

      let current = 0;
      _.map(_.range(0, frames), (f) => {
        // First frame intentionally skipped
        if (f >= 0) {
          this.queue.defer((cb) => { captureFrame(f, cb); });
        }
      });

      this.queue.awaitAll((error, result) => {
        if (error) {
          // console.log(error);
          gif.abort();
        } else {
          gif.render();
        }
      });
    } else {
      throw Error('Call createAnimation() first, this.animation is empty');
    }
  }

  private captureAnimationToVideo(callback?, bps?: number) {

    let that = this;

    if (this.animation) {
      this.reinitialize();
      let duration = this.animation.duration();
      let frames = duration * 60;
      let delay = 1000 * duration / frames;
      // console.log(delay);

      let data = [];
      let canvas = document.createElement('canvas');
      canvas.width = that.width;
      canvas.height = that.height;
      let context = canvas.getContext('2d');
      // @ts-ignore
      // let stream = canvas.captureStream(this.frameRate);
      let stream = canvas.captureStream(60);
      let options = {
        mimeType: 'video/webm',
        videoBitsPerSecond: bps || 10000000,
        // videoBitsPerSecond: bps || 2500000,
      };
      let recorder = new MediaRecorder(stream, options);

      recorder.ondataavailable = function(event) {
        if (event.data && event.data.size) {
          data.push(event.data);
        }
      };

      recorder.onstop = () => {
        let blob = new Blob(data, { type: 'video/webm' });
        let url = URL.createObjectURL(blob);
        this.videoBlobEmitter.emit(blob);
        this.videoDataUrlEmitter.emit(url);
      };

      this.queue = d3.queue(1);

      let captureFrame = (f, cb) => {
        let progress = f / frames;
        // console.log(progress);
        this.animation.progress(progress);
        this.progressEmitter.emit(progress);
        let xml = new XMLSerializer().serializeToString(this.svgElement);
        let blob = new Blob([xml], { type: 'image/svg+xml' });
        let img = new Image();
        img.crossOrigin = 'Anonymous';

        img.onload = function() {
          context.drawImage(img, 0, 0, that.width, that.height);
          cb(null, img);
        };

        img.src = URL.createObjectURL(blob);

        return {
          abort: () => { console.log('Abort'); }
        };
      };

      let current = 0;
      _.map(_.range(0, frames), (f) => {
        // First frame intentionally skipped
        if (f !== 0) {
          this.queue.defer((cb) => { captureFrame(f, cb); });
        }
      });

      this.queue.awaitAll((error, frames) => {
        if (error) {
          // console.log(error);
        } else {
          recorder.start();
          drawFrame();

        }
        function drawFrame() {
          if (frames.length) {
            context.drawImage(frames.shift(), 0, 0, that.width, that.height);
            // setTimeout(() => { requestAnimationFrame(drawFrame); }, delay);
            requestAnimationFrame(drawFrame);
          } else {
            recorder.stop();
          }
        }
      });

    } else {
      throw Error('Call createAnimation() first, this.animation is empty');
    }
  }

  public async setParam(param: any) {
    // console.log('setParam');
    // console.log(param);
    this.parameters[param['key']] = param['value'];
    return this.createAll(this.animation.paused());
  };

  public async setTiming(timing: any) {
    // console.log('setTiming');
    this.timings[timing['key']] = timing['value'];
    return this.createAll();
  };

  public getDataValues() {
    let rowLabelNumber = this.params['data']['rowLabelNumber'] || 0;
    let columnLabelNumber = this.params['data']['columnLabelNumber'] || 0;

    let dataValues = [];
    for (let i = 0; i < this.data.length; i++) {
      let row = this.data[i];
      if (i >= columnLabelNumber) {
        let newRow = [];
        for (let ii = 0; ii < row.length; ii++) {
          if (ii >= rowLabelNumber) {
            newRow.push(row[ii]);
          }
        }
        dataValues.push(newRow);
      }
    }
    // console.log(dataValues);
    return dataValues;
  }

  public async setData(data: any) {
    // console.log('setData');
    this.data = data;
    return this.createAll();
  };

  @Input() public set scalable(s) {
    this._scalable = s;
    if (this.parameters) {
      this.setParam({ 'key': 'scalable', 'value': this._scalable });
    }
  }

  @Input() public set embedFonts(e) {
    this._embedFonts = e;
    if (this.parameters) {
      this.setParam({ 'key': 'embedFonts', 'value': this._embedFonts });
    }
  }

  public async setScalable(s) {
    this._scalable = s;
    if (this.parameters) {
      return this.setParam({ 'key': 'scalable', 'value': this._scalable });
    }
  }

  public async setEmbedFonts(e) {
    this._embedFonts = e;
    if (this.parameters) {
      return this.setParam({ 'key': 'embedFonts', 'value': this._embedFonts });
    }
  }

  public kill() {
    if (this.animation) {
      this.animation.kill();
    }
  }

  public abortRender() {
    if (this.queue) {
      this.queue.abort();
    }
  }

  public play() {
    if (this.animation) {
      this.animation.play();
    }
  }

  public pause() {
    if (this.animation) {
      this.animation.pause();
    }
  }

  public resume() {
    if (this.animation) {
      this.animation.resume();
    }
  }

  public reverse() {
    if (this.animation) {
      this.animation.reverse();
    }
  }

  public restart() {
    if (this.animation) {
      this.animation.restart();
    }
  }

  public reinitialize() {
    if (this.animation) {
      this.animation.pause();
      this.animation.progress(0);
    }
  }

  public stopForStill() {
    if (this.animation) {
      this.animation.pause(0);
      let time = this.findLabelTime(this.animation, 'positionForStill');
      if (time >= 0) {
        this.animation.time(time);
      } else {
        this.animation.time(0);
      }
    }
    this.svgEmitter.emit(this.svgElement);
  }

  public hasPositionForStill() {
    return this.animation && this.hasLabel(this.animation, 'positionForStill');
  }

  public hasLabel(timeline, label) {
    return this.findLabelTime(timeline, label) >= 0;
  }

  public findLabelTime(timeline, label) {
    let time = timeline.getLabelTime(label); // Check to see if the label exists in the top-level timeline
    let i = 0, children, tl;
    if (time !== -1) { // If the label exists in the top-level timeline, return it
      return time;
    }
    children = timeline.getChildren(true, false, true); // Get all children timelines, params: (nested, tweens, timelines, ignoreBeforeTime)
    while (time === -1 && i < children.length) {
      tl = children[i];
      time = tl.getLabelTime(label); // Get the time for the label
      i++;
    }
    if (time === -1) { // If the label wasn't found return -1
      return -1;
    }
    time = tl.startTime() + time / tl.timeScale();
    tl = tl.timeline; // Get parent timeline
    while (tl && tl !== timeline) { // If there is a parent and the parent is not the top-level timeline
      time = tl.startTime() + time / tl.timeScale(); // startTime() gets the time at which the timeline begins on its parent
      tl = tl.timeline;
    }
    return time;
  }

  public formatNumberWithSpaces(number: number, decimals: number) {
    let str = (number || 0).toLocaleString('nl', {
      minimumFractionDigits: decimals
    });
    str = str.split('.').join(' ');
    return str;
  }

  public formatNumber(number: number, format: string, locale?: string): string {
    // console.log(`Format is ${format}`);
    if (number !== undefined && number !== null && format !== '') {
      if (locale && locale !== '') {
        numeral.locale(locale);
      } else {
        numeral.locale('nl-nl');
      }
      let formattedNumber = numeral(number).format(format);
      if (locale === 'nl-nl') {
        formattedNumber = _.replace(formattedNumber, new RegExp('\\.', 'g'), ' ');
      }
      return formattedNumber;
    } else {
      // console.log(`Cannot format number ${number} with format ${format}`);
      return number ? number.toString() : null;
    }
  }

  public formatNumberDecimals(number: number, decimals: number, locale?: string): string {
    let format = '#,###';
    if (decimals > 0) {
      format = format + '.' + _.repeat('0', decimals);
    }
    let formattedNumber = this.formatNumber(number, format, locale);
    return formattedNumber;
  }

  public splitStringNumbers(string: string, locale?: string) {
    let regEx;
    switch (locale) {
      case 'en-gb':
        regEx = /(\d+(?:,{1}\d{3})*(?:.{1}\d*){0,1})/g;
        break;
      default:
        regEx = /(\d+(?:(?: |.){1}\d{3})*(?:,{1}\d*){0,1})/g;
    }
    let array = string.split(regEx).map(elem => {
      if (regEx.test(elem)) {
        return {
          type: 'number',
          text: elem,
          number: this.makeNumber(elem, locale)
        }
      } else {
        return {
          type: 'text',
          text: elem,
        }
      }
    });
    return array
  }

  public splitStringNumbersAndSpecialChars(string: string, locale?: string, specialChars?) {
    let regEx;
    switch (locale) {
      case 'en-gb':
        regEx = /(\d+(?:,{1}\d{3})*(?:.{1}\d*){0,1}|\%|\€)/g;
        break;
      default:
        regEx = /(\d+(?:(?: |.){1}\d{3})*(?:,{1}\d*){0,1}|\%|\€)/g;
    }
    let array = string.split(regEx).map(elem => {
      if (regEx.test(elem)) {
        return {
          type: 'number',
          text: elem,
          number: this.makeNumber(elem, locale)
        }
      } else {
        return {
          type: 'text',
          text: elem,
        }
      }
    });
    return array
  }

  public makeNumber(str, locale) {
    let number;
    switch (locale) {
      case 'en-gb':
        number = parseFloat(str.replace(',', ''));
        break;
      default:
        number = parseFloat(str.replace(' ', '').replace('.', '').replace(',', '.'));
    }
    return number
  }

  public lightenDarkenColor(col, amt) {
    let usePound = true;
    if ( col[0] === '#' ) {
      col = col.slice(1);
      usePound = true;
    }
    let num = parseInt(col, 16);

    let r = (num >> 16) + amt;
    if ( r > 255 ) {r = 255}
    else if (r < 0) {r = 0};

    let b = ((num >> 8) & 0x00FF) + amt;
    if ( b > 255 ) {b = 255}
    else if (b < 0) {b = 0};

    let g = (num & 0x0000FF) + amt;
    if ( g > 255 ) {g = 255}
    else if  ( g < 0 ) {g = 0};

    let newHex = ('000000' + (g | (b << 8) | (r << 16)).toString(16)).slice(-6);
    return (usePound ? '#' : '') + newHex;
  }

  public flipElementHorizontally(group) {
    let element = group.node();
    let bound = element.getBBox();
    // console.log(bound);
    group.attr('transform', `translate(${bound.x + bound.x + bound.width}, 0) scale(-1, 1)`);
  }

  public createSVGElement(elem: string) {
    let element = document.createElementNS('http://www.w3.org/2000/svg', elem);
    element.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns:xlink', 'http://www.w3.org/1999/xlink');
    return d3.select(element);
  }

  public appendToSelection(selection) {
    return selection;
  }

  public getDataURL(url: string) {
    let p = new Promise(function(resolve, reject) {
      let image = new Image();
      image.crossOrigin = 'Anonymous';
      image.onload = function() {
        let canvas = document.createElement('canvas');
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;

        canvas.getContext('2d').drawImage(image, 0, 0);
        let URL = canvas.toDataURL('image/png');
        resolve(URL);
      }
      image.onerror = function() {
        reject('Image not found');
      }
      image.src = url;
    });
    return p;
  }

  public getPNG() {
    let that = this;
    let p = new Promise(function(resolve, reject) {
      let svgCopy = that.svgElement.cloneNode(true);
      let width = that.width;
      let height = that.height;
      svgCopy.setAttribute('width', width);
      svgCopy.setAttribute('height', height);
      let canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      let ctx = canvas.getContext('2d');
      let svgString = new XMLSerializer().serializeToString(svgCopy);
      let imgSrc = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgString)));
      let image = document.createElement('img');
      image.onload = () => {
        ctx.drawImage(image, 0, 0);
        canvas.toBlob(resolve);
      };
      image.setAttribute('src', imgSrc);
      image.onerror = function() {
        reject('Creating png from image failed');
      }
    });
    return p;
  }

  public getSize(selection) {
    let element = selection.node();
    let bound = element.getBBox();
    let boundRect = element.getBoundingClientRect();
    // console.log(boundRect);
    return bound;
  }

  public getRoundedRectangle(x: number, y: number, width: number, height: number, rTL: number, rTR: number, rBR: number, rBL: number): string {
    let rectString: string = `M${x}, ${y} `;
    if (rTL < 0 || rTR < 0 || rBR < 0 || rBL < 0) {
      console.error(`Radii should be larger than 0`);
    }
    if (rTL + rTR > width || rBR + rBL > width) {
      console.error(`Left + right radii can't be larger than total width`);
    }
    if (rTL !== 0) {
      rectString = rectString + `m0, ${rTL} a${rTL}, ${rTL} 0 0 1 ${rTL}, -${rTL} `;
    }
    rectString = rectString + `h${width - rTL - rTR} `;
    if (rTR !== 0) {
      rectString = rectString + `a${rTR}, ${rTR} 0 0 1 ${rTR}, ${rTR} `;
    }
    rectString = rectString + `v${height - rTR - rBR} `;
    if (rBR !== 0) {
      rectString = rectString + `a${rBR}, ${rBR} 0 0 1 -${rBR}, ${rBR} `;
    }
    rectString = rectString + `h-${width - rBL - rBR} `;
    if (rBL !== 0) {
      rectString = rectString + `a${rBL}, ${rBL} 0 0 1 -${rBL}, -${rBL}`;
    }
    rectString = rectString + `v-${height - rTR - rBR} Z`;
    // console.log(rectString);
    return rectString;
  }

}



// WEBPACK FOOTER //
// ./src/app/animations/animation-base-classes/animation.component.ts